import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import SidebarComponent from './Sidebar/SidebarComponent';
import NavbarComponent from './Navbar/NavbarComponent';
import {
  DASHBOARD_PAGE_PATH,
  ERROR403_PAGE_PATH,
  FORGOT_PASSWORD_PAGE_PATH,
  LOGIN_PAGE_PATH,
  MAINTANANCE_PAGE_PATH,
  OTPVERIFY_PAGE_PATH,
  PHOTON360_VIEWER_PAGE_PATH,
  RESET_PASSWORD_PAGE_PATH,
  RESET_PASSWORD_PAGE_PATH_TOKEN
} from '../constants/appPathConst';
import { MD, SM, XS } from '../constants/screenSizeConst';
import FullLayout from './FullLayout';
import useWindowDimensions from '../hooks/useWindowDimensions';
import benames from '../generalUtils/benames';
import { generateBreadcrumbs, getTitleOfPage } from '../generalUtils/pageInfo';
import { performThemeFn } from '../generalUtils/themeStyleTag';
import { cancelPreviousPageRequests } from '../services/Api';
import usePrevious from '../hooks/usePrevious';
import AnnouncementBar from '../pages/AnnouncementsBanner/AnnouncementBar';
import { STORAGE_USER_VIEW } from '../constants/storageConst';

const bemClass = benames.create('layout');

const MainLayout = props => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location?.pathname || DASHBOARD_PAGE_PATH;
  const previousPath = usePrevious(currentPath);

  const obj = useWindowDimensions();
  const { screenSizeType } = obj;
  const {
    user,
    screenSizeObj,
    handleLayoutIsDisplaySidebar,
    handlePageTitleNBreadCrumb,
    handleLayoutScreenSizeObj,
    goback,
    children,
    token,
    view
  } = props;
  const userId = user?.user_id;

  useEffect(() => {
    const getTheme = async () => {
      await performThemeFn({ user_id: userId, token });
    };
    getTheme();
  }, [token, userId]);

  useEffect(() => {
    if (previousPath !== currentPath) {
      cancelPreviousPageRequests(previousPath);
    }
  }, [currentPath]);

  useEffect(() => {
    if (user) {
      if (screenSizeObj?.screenSizeType !== screenSizeType) {
        handleLayoutScreenSizeObj(obj);

        const isSmallScreen = [MD, SM, XS].includes(screenSizeType);
        handleLayoutIsDisplaySidebar(!isSmallScreen);
      }
    }
  }, [user, screenSizeType]);

  useEffect(() => {
    if (user) {
      const secondSlashIndex = currentPath.indexOf('/', 1);
      const defaultPath = secondSlashIndex !== -1 ? currentPath.substring(0, secondSlashIndex) : currentPath;

      const objPage = {};
      objPage.pageTitle = getTitleOfPage(defaultPath);
      objPage.pageBreadCrumb = generateBreadcrumbs(defaultPath);
      handlePageTitleNBreadCrumb(objPage);
    }
  }, [user, currentPath]);

  useEffect(() => {
    localStorage.setItem(STORAGE_USER_VIEW, JSON.stringify(view));
  }, [view]);

  const allowedPublicPaths = [
    ERROR403_PAGE_PATH,
    MAINTANANCE_PAGE_PATH,
    RESET_PASSWORD_PAGE_PATH,
    LOGIN_PAGE_PATH,
    OTPVERIFY_PAGE_PATH,
    FORGOT_PASSWORD_PAGE_PATH,
    RESET_PASSWORD_PAGE_PATH_TOKEN
  ];

  if (allowedPublicPaths.some(path => currentPath.startsWith(path))) {
    return <FullLayout {...props} navigate={navigate} />;
  }

  if ([PHOTON360_VIEWER_PAGE_PATH].some(path => currentPath.includes(path))) {
    return <div>{children}</div>;
  }
  if (!user) {
    return <Navigate to={LOGIN_PAGE_PATH} />;
  }

  return (
    <>
      <AnnouncementBar isPreview={false} />
      <div className={bemClass.b('')}>
        <SidebarComponent {...props} location={location} navigate={navigate} />
        <div className="cr-content">
          <NavbarComponent toggleBack={goback} {...props} location={location} navigate={navigate} />
          <div className="layout__content">{children}</div>
        </div>
      </div>
    </>
  );
};

MainLayout.displayName = 'MainLayout';
export default MainLayout;
